module.exports = __webpack_public_path__ + "img/icon_sm_kwgl.d292c6b4.png";